import React from "react";
import Lottie from "react-lottie";

import * as animationData from "../../../animations/info-button.json";

const LookMobileInfoButtonAnimatedIcon = () => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Lottie options={defaultOptions} />
  )
};

export default LookMobileInfoButtonAnimatedIcon
